
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5521',
  depVersions: {
  "data-privacy-request-ui": "static-1.5521",
  "data-fetching-client": "static-1.9664",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.8008",
  "hub-http-shared-msw-handlers": "static-1.9940",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11463",
  "I18n": "static-7.1624",
  "jasmine-runner": "static-1.6460",
  "privacy-center-public-service-types": "static-1.4784",
  "quartz": "static-1.7024",
  "react-dlb": "static-1.78",
  "ui-components-test-utils": "static-1.5600",
  "UIComponents": "static-3.8409",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.85",
  "foundations-assets": "static-1.4859",
  "foundations-components": "static-1.7923",
  "foundations-components-test-utils": "static-1.5406",
  "foundations-theming": "static-1.4411",
  "hub-http": "static-1.6217",
  "quartz-config": "static-1.802",
  "quartz-core": "static-1.6243",
  "quartz-routing": "static-1.454",
  "quick-fetch": "static-1.3912",
  "raven": "static-3.5907",
  "react": "static-7.185",
  "react-rhumb": "static-1.16664",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11145",
  "usage-tracker": "static-1.7338",
  "usage-tracker-anonymous": "static-1.5755",
  "usage-tracker-core": "static-1.7188",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4115",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3395",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3301",
  "quartz-webpack": "static-1.3248",
  "bend-plugin-quartz-routing": "static-1.102",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "HeadJS": "static-2.760",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3119",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "ts-schema": "static-1.4075",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.82",
  "react-utils": "static-2.5339",
  "StyleGuideUI": "static-3.487",
  "jasmine": "static-4.4322",
  "rpc-client-utils": "static-1.4644",
  "HubStyle": "static-2.11770",
  "ui-addon-draggable": "static-3.4758",
  "cssUtils": "static-1.790",
  "hs-story-utils": "static-1.9421",
  "icons": "static-2.646",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1153",
  "bend-plugin-foundations-components": "static-1.4192",
  "floating-ui": "static-1.55",
  "foundations-theming-specialty": "static-1.2127",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.22",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1909",
  "ui-fonts": "static-1.725",
  "foundations-components-legacy": "static-1.948",
  "bend-plugin-foundations-theming": "static-1.2894",
  "foundations-theming-base": "static-1.3396",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.76",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.833",
  "hubspotter-http": "static-1.4647",
  "mobile-manifest-mixins": "static-1.534",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.699",
  "quartz-head": "static-1.689",
  "quartz-i18n": "static-1.699",
  "quartz-test": "static-1.699",
  "quartz-tracking": "static-1.403",
  "usage-tracker-container": "static-1.7328",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3199",
  "bend-plugin-chirp-manifest": "static-1.54",
  "chirp-fetch": "static-1.1881",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.69",
  "sassPrefix": "static-1.155",
  "hubspotter-http-shared-msw-handlers": "static-1.9938",
  "usage-tracker-session-replay": "static-1.5024",
  "amplitude-session-replay-browser": "static-1.59"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5521",
  "data-fetching-client": "/data-fetching-client/static-1.9664",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.8008",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9940",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11463",
  "I18n": "/I18n/static-7.1624",
  "jasmine-runner": "/jasmine-runner/static-1.6460",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4784",
  "quartz": "/quartz/static-1.7024",
  "react-dlb": "/react-dlb/static-1.78",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5600",
  "UIComponents": "/UIComponents/static-3.8409",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "foundations-assets": "/foundations-assets/static-1.4859",
  "foundations-components": "/foundations-components/static-1.7923",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5406",
  "foundations-theming": "/foundations-theming/static-1.4411",
  "hub-http": "/hub-http/static-1.6217",
  "quartz-config": "/quartz-config/static-1.802",
  "quartz-core": "/quartz-core/static-1.6243",
  "quartz-routing": "/quartz-routing/static-1.454",
  "quick-fetch": "/quick-fetch/static-1.3912",
  "raven": "/raven/static-3.5907",
  "react": "/react/static-7.185",
  "react-rhumb": "/react-rhumb/static-1.16664",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11145",
  "usage-tracker": "/usage-tracker/static-1.7338",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5755",
  "usage-tracker-core": "/usage-tracker-core/static-1.7188",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3395",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3301",
  "quartz-webpack": "/quartz-webpack/static-1.3248",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.102",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "HeadJS": "/HeadJS/static-2.760",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3119",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "ts-schema": "/ts-schema/static-1.4075",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.82",
  "react-utils": "/react-utils/static-2.5339",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "jasmine": "/jasmine/static-4.4322",
  "rpc-client-utils": "/rpc-client-utils/static-1.4644",
  "HubStyle": "/HubStyle/static-2.11770",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4758",
  "cssUtils": "/cssUtils/static-1.790",
  "hs-story-utils": "/hs-story-utils/static-1.9421",
  "icons": "/icons/static-2.646",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1153",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4192",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2127",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.22",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1909",
  "ui-fonts": "/ui-fonts/static-1.725",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.948",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2894",
  "foundations-theming-base": "/foundations-theming-base/static-1.3396",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.76",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.833",
  "hubspotter-http": "/hubspotter-http/static-1.4647",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.534",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.699",
  "quartz-head": "/quartz-head/static-1.689",
  "quartz-i18n": "/quartz-i18n/static-1.699",
  "quartz-test": "/quartz-test/static-1.699",
  "quartz-tracking": "/quartz-tracking/static-1.403",
  "usage-tracker-container": "/usage-tracker-container/static-1.7328",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.54",
  "chirp-fetch": "/chirp-fetch/static-1.1881",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.69",
  "sassPrefix": "/sassPrefix/static-1.155",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9938",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5024",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59"
}
};
